"use strict";

// Inspection URLs are nested under the data view they were opened from, so reloading or sharing
// one lands back in the same tool. The same asset can be inspected from several data views
// (e.g. an outfall from IDDE's Dry Weather view or Muni's Outfalls view).
const InspectionUrl = function () {
  var get = function ({ tool, dataView, assetType, assetId, inspectionId }) {
    const path = `/ram/${tool}/${dataView}/${assetType}/${assetId}/inspection`;
    return inspectionId ? `${path}/${inspectionId}` : path;
  };

  var getForCurrentView = function (assetType, assetId, inspectionId = null) {
    return get({
      tool: Tree.get("tool"),
      dataView: Tree.get("dataView"),
      assetType,
      assetId,
      inspectionId,
    });
  };

  return {
    get,
    getForCurrentView,
  };
};

module.exports = InspectionUrl();

const Tree = require("../../tree");
